import axios, { AxiosInstance } from "axios";

/* global process */

const REACT_APP_BASE_PRIVATE_API_URL =
  process.env.REACT_APP_BASE_PRIVATE_API_URL;

const instance: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: REACT_APP_BASE_PRIVATE_API_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

export default instance;
